
export enum RouteCondition {
    LIST = 'LIST',
    EDIT = 'EDIT',
    UNSET = 'UNSET' // default
}

export enum RouteOutlet {
    EDIT = 'edit',
    MODAL = 'modal'
}

export enum RoutePath {
    LIST = 'list',
    LIST_SHIENKEIKA = 'list-shienkeika',
    LIST_DETAIL = 'detail/:noteid',
    FACESHEET = 'facesheet',
    NOT_FOUND = '**',
}

export enum OutletRoutePath {
    USER_SELECT_FACESHEET = 'user-selector-facesheet',
    USER_SELECT_RECORD = 'user-selector-record',
    USER_SELECT_CASEFILE = 'user-selector-casefile',
    MENU_SELECT_CASEFILE = 'menu-selector-casefile',
    DEV_MENU = 'menu',
}

export const routeOutlets: string[] = [RouteOutlet.EDIT, RouteOutlet.MODAL];